import type {
  BookingPaymentSessionCreateFromSlugApiData,
  BookingPaymentSessionCreateFromSlugApiResponses
} from '@navio/nsdk';

import type { ApiInput } from '../../utils';
import { apiUrl, responseEndpoint } from '../defineResource';
import { paymentSessionAnalyticsBody, type PaymentSessionAnalyticsInput } from '../paymentSessionAnalytics';

// Public payment session by booking slug (SMS pay-link / anonymous). Body fields
// are ahead of nsdk until the BE OpenAPI publish lands.
export const bookingPaymentSessionUrls = {
  postBookingPaymentSessionFromSlug: responseEndpoint<
    BookingPaymentSessionCreateFromSlugApiData,
    BookingPaymentSessionCreateFromSlugApiResponses,
    ApiInput<BookingPaymentSessionCreateFromSlugApiData> & PaymentSessionAnalyticsInput
  >({
    getUrl: ({ slug }) => apiUrl(`bookings/info-from-slug/${slug}/payment-session/`),
    getBody: paymentSessionAnalyticsBody
  })
};
